import { Injectable } from '@angular/core';
import { clientHostModel } from '../models/clientHost.model';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {
  private clientHostModel: clientHostModel = {
    tenant: '',
    host: ''
  };

  public setClientHost(tenant: string, clientHost: string): void {
    this.clientHostModel.tenant = tenant;
    this.clientHostModel.host = clientHost;
  }

  public getClientHost(): string {
    return this.clientHostModel.host;
  }
}